module.exports = __webpack_public_path__ + "20250721160708/img/map.c92beb05.png";